import type { BenefitOwnershipDto } from "./benefit-types"

export const benefitOwnershipAssignmentPermission = "benefit-applications:assign-ownership"

/** UI capability derived from the server's effective permission response, never from a role slug. */
export function canReassignBenefitOwnership(permissions: string[]): boolean {
  return permissions.includes(benefitOwnershipAssignmentPermission)
}

export function ownerDisplay(ownership: BenefitOwnershipDto | null | undefined, legacyStaff?: string | null): string {
  if (!ownership?.isExplicit && legacyStaff?.trim()) return legacyStaff
  return ownership?.displayName ?? "Unassigned"
}
